import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "auth-brand" }
const _hoisted_3 = { class: "brand-icon" }
const _hoisted_4 = { class: "auth-right" }
const _hoisted_5 = { class: "auth-form-area" }
const _hoisted_6 = { class: "auth-header" }
const _hoisted_7 = {
  key: 0,
  class: "auth-label"
}
const _hoisted_8 = { class: "auth-title" }
const _hoisted_9 = {
  key: 1,
  class: "auth-subtitle"
}

import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
    label: {},
    title: {},
    subtitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseIcon, {
          name: "layers",
          size: 18,
          "stroke-width": 2.5
        })
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "brand-name" }, "Pulse", -1))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"auth-left\" aria-hidden=\"true\" data-v-60913cda><div class=\"circles-wrap\" data-v-60913cda><div class=\"ring ring--outer\" data-v-60913cda></div><div class=\"ring ring--inner\" data-v-60913cda></div><div class=\"glow-core\" data-v-60913cda></div><svg class=\"sparkle\" width=\"56\" height=\"56\" viewBox=\"0 0 56 56\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-60913cda><path d=\"M28 4C28 4 30 20 34 26C38.5 33 52 28 52 28C52 28 38.5\n               23 34 30C30 36 28 52 28 52C28 52 26 36 22 30C18 23\n               4 28 4 28C4 28 18 33 22 26C26 20 28 4 28 4Z\" fill=\"currentColor\" data-v-60913cda></path><path d=\"M42 10C42 10 43 17 45 20C47.5 24 54 22 54 22C54 22\n               47.5 20 45 24C43 27 42 34 42 34C42 34 41 27 39 24\n               C37 20 30 22 30 22C30 22 37 24 39 20C41 17 42 10 42 10Z\" fill=\"currentColor\" opacity=\"0.55\" data-v-60913cda></path></svg></div><div class=\"left-footer\" data-v-60913cda><p class=\"left-tagline\" data-v-60913cda> Monitor your users and platform health in real time.<br data-v-60913cda> Stay in control, always. </p><div class=\"trust-badges\" data-v-60913cda><span class=\"badge\" data-v-60913cda><span class=\"badge-dot\" data-v-60913cda></span>256-bit SSL encrypted</span><span class=\"badge\" data-v-60913cda><span class=\"badge-dot\" data-v-60913cda></span>Role-based access control</span><span class=\"badge\" data-v-60913cda><span class=\"badge-dot\" data-v-60913cda></span>99.9% uptime</span></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "header-icon"),
          (__props.label)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.label), 1))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_8, _toDisplayString(__props.title), 1),
          (__props.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})